// 图片资源管理
// 使用 require.context 动态导入 assets/images 下的所有图片
const imagesContext = require.context('@/assets/images', false, /\.(png|jpe?g|svg|gif)$/)

const imageMap = {}
imagesContext.keys().forEach(key => {
  // key 格式为 './xxx.png'
  const fileName = key.replace('./', '')
  // require.context 返回的是模块，需要通过 .default 获取实际的图片 URL
  const module = imagesContext(key)
  imageMap[fileName] = module.default || module
})

// 添加调试日志，打印已加载的图片
// console.log('Loaded images:', Object.keys(imageMap))

// 创建一个安全的图片获取函数
const getImage = (fileName) => {
  const url = imageMap[fileName]
  if (!url) {
    console.warn(`Image not found: ${fileName}`)
    return ''
  }
  return url
}

// 获取后端图片地址（自动添加域名前缀）
// 后端返回的图片地址可能是相对路径，需要加上API域名
const getServerImage = (imgUrl) => {
  if (!imgUrl) {
    return ''
  }
  // 如果已经是完整的HTTP/HTTPS地址，直接返回
  if (/^https?:\/\//i.test(imgUrl)) {
    return imgUrl
  }
  // 获取后端API域名
  // 注意：空字符串 '' 表示生产环境不需要添加域名前缀（同源部署）
  // 只有未设置或设置了具体值时才添加前缀
  const envBaseUrl = process.env.VUE_APP_BASE_API
  const hasBaseUrl = envBaseUrl !== undefined && envBaseUrl !== ''
  
  if (!hasBaseUrl) {
    // 生产环境且未配置域名，直接返回相对路径（同源部署）
    return imgUrl
  }
  
  // 添加后端API域名前缀
  const baseUrl = envBaseUrl
  // 确保URL格式正确（处理可能的重复斜杠）
  const normalizedUrl = imgUrl.startsWith('/') ? imgUrl : `/${imgUrl}`
  return baseUrl.replace(/\/$/, '') + normalizedUrl
}

// 处理HTML字符串中的图片地址，为相对路径添加域名前缀
// 适用于v-html渲染的富文本内容
const processHtmlImages = (htmlString) => {
  if (!htmlString || typeof htmlString !== 'string') {
    return htmlString || ''
  }
  // 获取后端API域名
  // 注意：空字符串 '' 表示生产环境不需要添加域名前缀（同源部署）
  const envBaseUrl = process.env.VUE_APP_BASE_API
  const hasBaseUrl = envBaseUrl !== undefined && envBaseUrl !== ''
  
  if (!hasBaseUrl) {
    // 生产环境且未配置域名，直接返回原HTML（同源部署）
    return htmlString
  }
  
  const normalizedBaseUrl = envBaseUrl.replace(/\/$/, '')
  
  // 使用正则表达式匹配所有img标签的src属性
  // 匹配模式：<img[^>]*src=["']([^"']+)["'][^>]*>
  const imgRegex = /<img([^>]*)src=["']([^"']+)["']([^>]*)>/gi
  
  return htmlString.replace(imgRegex, (match, beforeSrc, src, afterSrc) => {
    // 如果src已经是完整的HTTP/HTTPS地址，直接返回原标签
    if (/^https?:\/\//i.test(src)) {
      return match
    }
    // 否则为相对路径添加域名前缀
    const normalizedSrc = src.startsWith('/') ? src : `/${src}`
    const fullSrc = normalizedBaseUrl + normalizedSrc
    return `<img${beforeSrc}src="${fullSrc}"${afterSrc}>`
  })
}

export { imageMap, getImage, getServerImage, processHtmlImages }